module.exports = __webpack_public_path__ + "media/react/components/PatientBox/assets/andament_down_graph-76bb287b518beb1c130fb025fd64db4d.svg";